import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, FormTypeView, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiDeleteLocation, ApiGetLocationById, ApiInsertLocation, ApiUpdateLocation } from "utils/constants/api";
import { GetStatus, money } from "utils/helpers";
import moment from "moment";
import UnDeleteButton from "components/Button/UnDeleteButton";

export default function SalesForm(){
    let navigate = useNavigate()

    const{ fetch: createLocation } = useFetch(ApiInsertLocation)
    const{ fetch: updateLocation } = useFetch(ApiUpdateLocation)
    const{ fetch: deleteLocation } = useFetch(ApiDeleteLocation)
    const{ fetch: getLocationById } = useFetch(ApiGetLocationById)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramLocationId = queryString.get("locationId")

    const [locationName, setLocationName] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [city, setCity] = useState(EmptyString)
    const [province, setProvince] = useState(EmptyString)
    const [zipCode, setZipCode] = useState(EmptyString)
    const [tarrifCar, setTarrifCar] = useState(EmptyString)
    const [tarrifMotorcycle, setTarrifMotorcycle] = useState(EmptyString)
    const [tarrifValet, setTarrifValet] = useState(EmptyString)
    const [workingHourStart, setWorkingHourStart] = useState(EmptyString)
    const [workingHourEnd, setWorkingHourEnd] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const locationNameChange = (e) => { setLocationName(e.target.value) }
    const addressChange = (e) => { setAddress(e.target.value) }
    const cityChange = (e) => { setCity(e.target.value) }
    const provinceChange = (e) => { setProvince(e.target.value) }
    const zipCodeChange = (e) => { setZipCode(e.target.value) }
    const tarrifCarChange = (e) => { setTarrifCar(money(e.target.value)) }
    const tarrifMotorcycleChange = (e) => { setTarrifMotorcycle(money(e.target.value)) }
    const tarrifValetChange = (e) => { setTarrifValet(money(e.target.value)) }
    const workingHourStartChange = (e) => { 
        let char = e.target.value.replace(/[^0-9]/g, "")

        if (char.length > 2) {
            char = char.slice(0, 2) + ":" + char.slice(2, 4)
        }

        setWorkingHourStart(char)
    }
    const workingHourEndChange = (e) => { 
        let char = e.target.value.replace(/[^0-9]/g, "")

        if (char.length > 2) {
            char = char.slice(0, 2) + ":" + char.slice(2, 4)
        }

        setWorkingHourEnd(char)
    }

    const [errLocationName, setErrLocationName] = useState(false)
    const [errAddress, setErrAddress] = useState(false)
    const [errCity, setErrCity] = useState(false)
    const [errProvince, setErrProvince] = useState(false)
    const [errTarrifCar, setErrTarrifCar] = useState(false)
    const [errTarrifMotorcycle, setErrTarrifMotorcycle] = useState(false)
    const [errTarrifValet, setErrTarrifValet] = useState(false)
    const [errsWorkingHourStart, setErrsWorkingHourStart] = useState(false)
    const [errsWorkingHourEnd, setErrsWorkingHourEnd] = useState(false)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    

    // Button Event
    const saveBtnClick = () => {
        if (fFormValidation()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                if(formType === FormTypeAdd){
                    fCreateLocation().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    fUpdateLocation().then(() => {
                        setLoading({isOpen: false})
                    })
                }
            }}})
        }
    }
    const deleteBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            fDeleteLocation(status).then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    // API Calls
    async function fCreateLocation(){
        await createLocation({
            data: {
                locationName: locationName,
                address: address,
                city: city,
                province: province,
                zipCode: zipCode,
                tarrifCar: tarrifCar === EmptyString ? "0" : String(tarrifCar).replaceAll(",", ""),
                tarrifMotorcycle: tarrifMotorcycle === EmptyString ? "0" : String(tarrifMotorcycle).replaceAll(",", ""),
                tarrifValet: tarrifValet === EmptyString ? "0" : String(tarrifValet).replaceAll(",", ""),
                workingHourStart: workingHourStart,
                workingHourEnd: workingHourEnd

            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/location") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateLocation(){ 
        await updateLocation({
            data: {
                locationId: paramLocationId,
                locationName: locationName,
                address: address,
                city: city,
                province: province,
                zipCode: zipCode,
                tarrifCar: tarrifCar === EmptyString ? "0" : String(tarrifCar).replaceAll(",", ""),
                tarrifMotorcycle: tarrifMotorcycle === EmptyString ? "0" : String(tarrifMotorcycle).replaceAll(",", ""),
                tarrifValet: tarrifValet === EmptyString ? "0" : String(tarrifValet).replaceAll(",", ""),
                workingHourStart: workingHourStart,
                workingHourEnd: workingHourEnd
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/location") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetLocation(paramLocationId){
        await getLocationById({
            data: {
                locationId: String(paramLocationId)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                
                setLocationName(data.locationName)
                setAddress(data.address)
                setCity(data.city)
                setProvince(data.province)
                setZipCode(data.zipCode)
                setTarrifCar(data.tarrifCar === null ? "0" : money(data.tarrifCar))
                setTarrifMotorcycle(data.tarrifMotorcycle === null ? "0" : money(data.tarrifMotorcycle))
                setTarrifValet(data.tarrifValet === null ? "0" : money(data.tarrifValet))
                setWorkingHourStart(data.workingHourStart)
                setWorkingHourEnd(data.workingHourEnd)
                setStatus(data.status)
                setCreateDate(data.createdDate)
                setUpdateDate(data.updatedDate)
                setUpdateBy(data.updatedBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }  
    async function fDeleteLocation(status){
        await deleteLocation({
            data: {
                locationId: paramLocationId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                            navigate("/location")
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function
    function fFormValidation(){
        let errorCount = 0

        // if (formType === FormTypeEdit){
        //     if (companyId === null || companyId === EmptyString){
        //         errorCount++
        //         setErrCompanyId(true)
        //     }else{
        //         setErrCompanyId(false)
        //     }
        // }
        
        // if (companyName === null || companyName === EmptyString){
        //     errorCount++
        //     setErrCompanyName(true)
        // }else{
        //     setErrCompanyName(false)
        // }
        // if (npwp === null || npwp === EmptyString){
        //     errorCount++
        //     setErrNpwp(true)
        // }else{
        //     setErrNpwp(false)
        // }
        // if (address === null || address === EmptyString){
        //     errorCount++
        //     setErrAddress(true)
        // }else{
        //     setErrAddress(false)
        // }
        if (locationName === null || locationName === EmptyString){
            errorCount++
            setErrLocationName(true)
        }else{
            setErrLocationName(false)
        }
        if (address === null || address === EmptyString){
            errorCount++
            setErrAddress(true)
        }else{
            setErrAddress(false)
        }
        if (city === null || city === EmptyString){
            errorCount++
            setErrCity(true)
        }else{
            setErrCity(false)
        }
        if (province === null || province === EmptyString){
            errorCount++
            setErrProvince(true)
        }else{
            setErrProvince(false)
        }
        if (tarrifCar === null || tarrifCar === EmptyString){
            errorCount++
            setErrTarrifCar(true)
        }else{
            setErrTarrifCar(false)
        }
        if (tarrifMotorcycle === null || tarrifMotorcycle === EmptyString){
            errorCount++
            setErrTarrifMotorcycle(true)
        }else{
            setErrTarrifMotorcycle(false)
        }
        if (tarrifValet === null || tarrifValet === EmptyString){
            errorCount++
            setErrTarrifValet(true)
        }else{
            setErrTarrifValet(false)
        }
         if (workingHourStart === null || workingHourStart === EmptyString){
            errorCount++
            setErrsWorkingHourStart(true)
        }else{
            setErrsWorkingHourStart(false)
        }

         if (workingHourEnd === null || workingHourEnd === EmptyString){
            errorCount++
            setErrsWorkingHourEnd(true)
        }else{
            setErrsWorkingHourEnd(false)
        }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    
    useEffect(() => {
        if(formType === FormTypeEdit || formType === FormTypeView){
            // setLoading({isOpen: true})
            
            // fGetLocation(paramLocationId).then(() => {
            //     setLoading({isOpen: false})
            // })
        }
    }, [])

    return(
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">Sales Detail</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Location Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Location Name</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={locationName} onChange={locationNameChange} maxLength={50} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errLocationName ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Location Name is required!</span>
                    </div>
                </div>

                {/* Address */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-start">
                        <div className="w-48 pt-2">
                            <span>Address</span>
                        </div>
                        <div className="px-4 pt-2 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <textarea className="input" value={address} onChange={addressChange} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errAddress ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Address is required!</span>
                    </div>
                </div>

                {/* City */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>City</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={city} onChange={cityChange} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errCity ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">City is required!</span>
                    </div>
                </div>

                {/* Province */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Province</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={province} onChange={provinceChange} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errProvince ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Province is required!</span>
                    </div>
                </div>

                {/* Zip Code */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Zip Code</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={zipCode} onChange={zipCodeChange} maxLength={20} />
                        </div>
                    </div>
                    {/* <div className={`flex flex-wrap items-center ${ ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Phone is required!</span>
                    </div> */}
                </div>
            </div>

            <div className="mt-10 flex flex-col gap-3">
                <div>
                    <span className="font-semibold text-xl">Tarif</span>
                    <hr />
                </div>
                {/* Car */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Car</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={tarrifCar} onChange={tarrifCarChange} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errTarrifCar ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Tarrif Car is required!</span>
                    </div>
                </div>

                {/* Motorcycle */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Motorcycle</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={tarrifMotorcycle} onChange={tarrifMotorcycleChange} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errTarrifMotorcycle ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Tarrif Motorcycle is required!</span>
                    </div>
                </div>

                {/* Valet */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Valet</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={tarrifValet} onChange={tarrifValetChange} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errTarrifValet ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Tarrif Valet is required!</span>
                    </div>
                </div>
            </div>

            <div className="mt-10 flex flex-col gap-3">
                <div>
                    <span className="font-semibold text-xl">Working Hour</span>
                    <hr />
                </div>
                {/* Working Hour Start */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Start</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={workingHourStart} onChange={workingHourStartChange} maxLength={5} placeholder="HH:mm" />
                        </div>
                    </div>
                    <div className={`flex items-center ${errsWorkingHourStart ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Working Hour Start is required!</span>
                    </div>
                </div>
                {/* Working Hour End */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>End</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={workingHourEnd} onChange={workingHourEndChange} maxLength={5} placeholder="HH:mm" />
                        </div>
                    </div>
                    <div className={`flex items-center ${errsWorkingHourEnd ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Working Hour End is required!</span>
                    </div>
                </div>
            </div>
            

            <div className="mt-5 flex justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />                
                <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeActive ? true : false) : false} />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                <BackButton onClick={backBtnClick} />
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && ( <LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}